// extracted by mini-css-extract-plugin
export default {"container":"lZ-z","title":"mZ-z","link":"nZ-z"};